import profileImage from "../assets/img/avatars/profileImage.jpg";
import { handleOfferStatus, handleDeleteOffers } from "actions/actions";
import { toast } from "react-toastify";
import ImageModal from "../components/imageModel/imageMode.jsx";
import { useState } from "react";
import { localizeMeasurement, localizeStatus } from "utils/localization";

const BASE_URL = process.env.REACT_APP_ENDPOINT;

const OffersColumn = (refetch) => [
  {
    Header: "العنوان",
    accessor: "title",
  },
  {
    Header: "الوصف",
    accessor: "description",
  },
  {
    Header: "السعر",
    accessor: "price",
    Cell: ({ row }) => <span>{row.original.price} ريال</span>,
  },
  {
    Header: "وحدة القياس",
    accessor: "measurement",
    Cell: ({ row }) => localizeMeasurement(row.original?.measurement),
  },
  {
    Header: "مدة التنفيذ",
    accessor: "implementationPeriod",
  },
  {
    Header: "مع التركيب",
    accessor: "withInstallation",
    Cell: ({ row }) => (
      <span>{row.original.withInstallation ? "نعم" : "لا"}</span>
    ),
  },
  {
    Header: "شامل الشحن",
    accessor: "includedWithShipment",
    Cell: ({ row }) => (
      <span>{row.original.includedWithShipment ? "نعم" : "لا"}</span>
    ),
  },
  {
    Header: "المنطقة",
    accessor: "region",
  },
  {
    Header: "المدينة",
    accessor: "city",
  },
  {
    Header: "الحي",
    accessor: "district",
  },
  {
    Header: "الصورة",
    accessor: "photo",
    Cell: ({ row }) => {
      const [isModalOpen, setIsModalOpen] = useState(false);

      const handleImageClick = () => {
        setIsModalOpen(true);
      };

      const handleCloseModal = () => {
        setIsModalOpen(false);
      };

      return (
        <>
          <img
            src={
              row.original.photo
                ? `${BASE_URL}/${row.original.photo}`
                : profileImage
            }
            alt={row.values.id}
            className="h-12 w-12 cursor-pointer rounded-lg object-cover"
            crossOrigin="anonymous"
            onClick={handleImageClick}
          />
          {isModalOpen && (
            <ImageModal
              src={
                row.original.photo
                  ? `${BASE_URL}/${row.original.photo}`
                  : profileImage
              }
              onClose={handleCloseModal}
            />
          )}
        </>
      );
    },
  },
  {
    Header: "تاريخ البداية",
    accessor: "startDate",
    Cell: ({ row }) => {
      const date = new Date(row.original.startDate).toLocaleDateString("ar-EG");
      return <span>{date}</span>;
    },
  },
  {
    Header: "تاريخ الانتهاء",
    accessor: "endDate",
    Cell: ({ row }) => {
      const date = new Date(row.original.endDate).toLocaleDateString("ar-EG");
      return <span>{date}</span>;
    },
  },
  {
    Header: "اسم المقاول",
    accessor: "name",
    Cell: ({ row }) => {
      const [isModalOpen, setIsModalOpen] = useState(false);

      const handleImageClick = () => {
        setIsModalOpen(true);
      };

      const handleCloseModal = () => {
        setIsModalOpen(false);
      };

      return (
        <>
          <img
            src={
              row.original.photo
                ? `${BASE_URL}/${row.original.user?.photo}`
                : profileImage
            }
            alt={row.values.id}
            className="h-12 w-12 cursor-pointer rounded-lg object-cover"
            crossOrigin="anonymous"
            onClick={handleImageClick}
          />
          {isModalOpen && (
            <ImageModal
              src={
                row.original.photo
                  ? `${BASE_URL}/${row.original.user?.photo}`
                  : profileImage
              }
              onClose={handleCloseModal}
            />
          )}
        </>
      );
    },
  },
  {
    Header: "رقم الهاتف",
    accessor: "user.phoneNumber",
  },

  {
    Header: "حالة العرض",
    accessor: "status",
    Cell: ({ row }) => {
      return (
        <span
          className={`rounded-full px-2 py-1 text-xs ${
            row.values.status === "accepted"
              ? "bg-green-500 text-white"
              : row.values.status === "pending"
              ? "bg-yellow-500 text-white"
              : "bg-red-500 text-white"
          }`}
        >
          {localizeStatus(row.values.status)}
        </span>
      );
    },
  },
  {
    Header: "إجراء",
    accessor: "id",
    Cell: ({ row }) => {
      return (
        <div className="flex flex-col items-start gap-2">
          <button
            className=" rounded-full bg-green-500 px-6 py-1 text-white transition-all hover:bg-green-600 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
            onClick={() =>
              handleOfferStatus(row.original.id, "accept").then((res) => {
                if (res.error) {
                  toast.error(res.error);
                } else {
                  toast.success(res.success);
                  refetch();
                }
              })
            }
            disabled={
              row.original.status === "accepted" ||
              row.original.status === "rejected"
            }
          >
            قبول
          </button>

          <button
            className=" rounded-full bg-red-500 px-6 py-1 text-white transition-all hover:bg-red-600 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
            onClick={() =>
              handleOfferStatus(row.original.id, "reject").then((res) => {
                if (res.error) {
                  toast.error(res.error);
                } else {
                  toast.success(res.success);
                  refetch();
                }
              })
            }
            disabled={
              row.original.status === "accepted" ||
              row.original.status === "rejected"
            }
          >
            رفض
          </button>
          <button
            className="rounded-full bg-red-700 px-6 py-1 text-white transition-all hover:bg-red-900 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
            onClick={() =>
              handleDeleteOffers(row.original.id).then((res) => {
                if (res.error) {
                  toast.error(res.error);
                } else {
                  toast.success(res.success);
                  refetch();
                }
              })
            }
          >
            حذف
          </button>
        </div>
      );
    },
  },
];

export default OffersColumn;
